module.exports = __webpack_public_path__ + "img/origin_dixing.08f348e2.png";